/* istanbul ignore file */
export const FREE_SPINS_SWISS = 'freespinsswiss';
